import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    userAuthInfoPresentAction,
    logOutAction,
} from '../../../actions/usersActions'
import { getStatusAction } from '../../../actions/appActions'
import { userAuthInfoPresent } from '../../../helpers/authHelpers'
import Loader from '../../loaders'
import routes from '../../router/routes'
import { strings } from '../../../localization/strings'

class RequireAuthWrapper extends React.Component {
    getStatus = () => {
        this.props
            .getStatusAction(this.props.history)
            .then(() => this.setState({ ready: true }))
            .catch((error) => {
                if (error.additionalData)
                    window.showDialog({ message: error.additionalData }, () =>
                        this.props.logOutAction()
                    )
                else window.showDialog(error, () => this.props.logOutAction())
            })
    }

    authenticate = () => {
        this.props
            .userAuthInfoPresentAction(this.props.history)
            .then(() => this.getStatus())
            .catch(() =>
                window.showDialog(
                    { message: strings.exceptions.CredentialsExpired },
                    () => {
                        this.props.history.push(routes.logIn.path)
                    }
                )
            )
    }

    constructor(props) {
        super(props)
        this.state = { ready: false }

        if (
            this.props.route.requireAuth &&
            (!this.props.userStore.authenticated || !userAuthInfoPresent())
        )
            this.authenticate()
        else this.state.ready = true
    }

    render() {
        if (!this.state.ready) return <Loader />
        return this.props.children
    }
}

const mapDispatchToProps = {
    userAuthInfoPresentAction,
    getStatusAction,
    logOutAction,
}
const mapStateToProps = (store) => ({ userStore: store.user })
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(RequireAuthWrapper))
